module.exports = __webpack_public_path__ + "static/media/smart-freight.fe9b59ad.svg";